import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

// Import icons
import iconDashboard from '../assets/icon-dashboard.svg';
import iconActivities from '../assets/icon-activities.svg';
import iconAnalytics from '../assets/icon-analytics.svg';
import iconLeaderboard from '../assets/icon-leaderboard.svg';
import iconFriends from '../assets/icon-friends.svg';
import iconProfile from '../assets/icon-profile.svg';
import iconHelp from '../assets/icon-help.svg';
import logoApp from '../assets/logo-app.png';

const Sidebar = ({ isOpen = true }) => {
  const menuItems = [
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: iconDashboard
    },
    {
      path: '/activities',
      label: 'Activities',
      icon: iconActivities
    },
    {
      path: '/analytics',
      label: 'Analytics',
      icon: iconAnalytics
    },
    {
      path: '/leaderboard',
      label: 'Leaderboard',
      icon: iconLeaderboard
    },
    {
      path: '/friends',
      label: 'Friends',
      icon: iconFriends
    },
    {
      path: '/profile',
      label: 'Profile',
      icon: iconProfile
    },
    {
      path: '/help',
      label: 'Help',
      icon: iconHelp
    }
  ];

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <img src={logoApp} alt="Runstreak Logo" className="sidebar-logo" />
      </div>
      <nav className="sidebar-menu">
        {menuItems.map((item) => (
          <div key={item.path} className="sidebar-menu-item">
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `sidebar-menu-button ${isActive ? 'active' : ''}`
              }
            >
              <div className="sidebar-icon">
                {item.icon ? (
                  <img src={item.icon} alt={`${item.label} icon`} />
                ) : (
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                  </svg>
                )}
              </div>
              <span>{item.label}</span>
            </NavLink>
          </div>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
